var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5613 2.18578H16.918L9.244 9.86354C8.99549 10.112 8.99549 10.5163 9.244 10.7648C9.3664 10.8872 9.52959 10.9503 9.69279 10.9503C9.85599 10.9503 10.0192 10.8872 10.1416 10.7648L17.8193 3.08708V6.44379C17.8193 6.79615 18.1049 7.08174 18.4536 7.08174C18.8059 7.08174 19.0915 6.79615 19.0915 6.44379V1.55153C19.0915 1.19917 18.8059 0.913574 18.4536 0.913574H13.5613C13.209 0.913574 12.9234 1.19917 12.9234 1.55153C12.9271 1.90018 13.209 2.18578 13.5613 2.18578Z",
    fill: "#6921C4",
    stroke: "#6921C4",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72483 19.092H15.2697C17.3764 19.092 19.0863 17.3784 19.0863 15.2753V10.3089C19.0863 9.95656 18.8007 9.67467 18.4484 9.67467C18.096 9.67467 17.8141 9.96027 17.8141 10.3089V15.2716C17.8141 16.6737 16.6717 17.8161 15.2697 17.8161H4.72483C3.3228 17.8161 2.18041 16.6737 2.18041 15.2716V6.89658V4.73049C2.18041 3.32846 3.3228 2.18607 4.72483 2.18607H9.64675C9.99911 2.18607 10.281 1.90048 10.281 1.54811C10.281 1.19575 9.9954 0.910156 9.64675 0.910156H4.72483C2.61808 0.910156 0.908203 2.62374 0.908203 4.72678V6.89287V15.2716C0.908203 17.3784 2.62179 19.092 4.72483 19.092Z",
    fill: "#6921C4",
    stroke: "#6921C4",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.dbfb4af3.svg";
export { ForwardRef as ReactComponent };